module.exports = __webpack_public_path__ + "img/new_york.d04a47bc.jpg";